<div class="container">
  <div class="workSpaceIndexContainer" #workSpacesEl>
    <div class="workSpacesIndexWrapper">
      @for (workSpace of workSpaces; track workSpace; let number = $index) {
        <div
          class="workSpaceIndex"
          [class.active]="checkIsCurrentWorkSpace(number)"
          (click)="changeCurrentWorkSpace(number)"
          >
          <span class="workSpaceSpan">
            {{ number + 1 }}
          </span>
        </div>
      }
    </div>
  </div>
  <div class="collapseContainer">
    <gl-icon
      [name]="'undo'"
      class="collapse"
      [class.collapseOpen]="!isClosed"
      (click)="collapse()"
    ></gl-icon>
  </div>
</div>
@if (!isMobile) {
  <div class="workSpaces">
    @if (!isClosed) {
      <gl-loading-space-panel [isClosed]="isClosed"></gl-loading-space-panel>
    }
  </div>
}
@if (!isClosed && isCargoSpaceDefined(1) && !isMobile) {
  <gl-loading-spaces-summary></gl-loading-spaces-summary>
}
